<template>
  <l-layout :layout="['xs12']">
    <v-card>
      <v-card-title class="py-2">
        <span class="px-1"></span>
        <span
          :class="bcItems.length === 0 ? '':'primary--text'"
          :style="{cursor: bcItems.length === 0? '':'pointer'}"
          @click="pop(rules)"
          class="subheading"
        >违章规则列表</span>
        <v-icon class="mx-2" v-if="bcItems.length !== 0">$vuetify.icons.chevronRight</v-icon>
        <template v-for="(item, i) in bcItems">
          <span
            :class="i === bcItems.length - 1 ? 'grey--text':'primary--text'"
            :key="i"
            :style="{cursor: i === bcItems.length - 1 ? '':'pointer'}"
            @click="pop(item)"
            class="subheading"
          >{{item.name}}</span>
          <v-icon :key="i + 'divider'" class="mx-2" v-if="i < bcItems.length - 1">$vuetify.icons.chevronRight</v-icon>
        </template>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <v-btn @click="refresh" icon slot="activator">
            <v-icon>$vuetify.icons.refresh</v-icon>
          </v-btn>
          <span>刷新</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn
            @click="goNew()"
            class="py-0 my-0"
            icon
            slot="activator"
          >
            <v-icon>$vuetify.icons.add</v-icon>
          </v-btn>
          <span>添加规则</span>
        </v-tooltip>

      </v-card-title>
      <v-divider></v-divider>
      <!--<v-tooltip bottom open-delay="1500">-->
      <div>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          disable-initial-sort
          hide-actions
          item-key="name"
        >
          <template slot="no-data">
            <v-flex class="body-2 text-xs-center">
              <div v-if="loading">数据加载中...</div>
              <div v-else-if="errorData.error">
                <span>数据加载出错: {{errorData.message}}, code: {{errorData.code}}</span>
                <v-btn @click="refresh()" color="primary" flat>重新加载</v-btn>
              </div>
              <div class="grey--text" v-else>没有{{isRoot ? '' : '细分'}}规则</div>
            </v-flex>
          </template>
          <template slot="items" slot-scope="p">
            <tr
              @click="selected = selected === p.index ? -1: p.index"
              @dblclick="go(p.item)"
            >
              <td>
                <v-flex align-center layout>
                  <v-icon :color="selected === p.index ? 'primary' : ''" class="pr-4"
                  >{{hasChildren(p.item) ? 'mdi-folder':'mdi-file-document'}}
                  </v-icon>
                  {{p.item.name}}
                </v-flex>
              </td>
              <td
                :class="['text-xs-' + (header.align||'left')]"
                :key="i"
                v-for="(header, i) in headers.slice(1)"
                v-if="header.value"
              >
                <div>
                  <v-tooltip :disabled="!header.tooltip" bottom max-width="48em">
                    <div
                      :class="header.maxWidth? 'hide-more-content':'' "
                      :style="header.maxWidth?'max-width: ' + header.maxWidth:''"
                      class="d-inline-block"
                      slot="activator"
                    >
                      <div
                        :class="[header.monospaced? 'monospaced':'']"
                        :style="header.monospaced? {'width': header.monospaced + '!important'}:''"
                        v-if="tdItemValue(p.item[header.value], header) || !header.placeholder"
                      >
                        <span
                          :class="[header.clickable?'primary--text':'']"
                          :style="header.clickable?'cursor: point':''"
                        >{{tdItemValue(p.item[header.value], header)}}</span>
                      </div>
                      <span class="grey--text" v-else>{{header.placeholder}}</span>
                    </div>
                    <span>{{tdItemValue(p.item[header.value], header)}}</span>
                  </v-tooltip>
                  <span class="grey--text caption pl-4"
                        v-if="header.remark && header.remark.filter(p.item[header.value])">{{header.remark.text}}</span>
                </div>
              </td>

              <td @dblclick.stop class="text-xs-right mx-o py-0" style="width: 100px">
                <v-tooltip bottom>
                  <span>删除规则</span>
                  <v-btn @click="deleteRule(p.item)" class="mx-0" icon slot="activator" small>
                    <v-icon small>$vuetify.icons.delete</v-icon>
                  </v-btn>
                </v-tooltip>
                <v-tooltip bottom>
                  <span>规则详情</span>
                  <v-btn @click="goDetails(p.item)" class="mx-0" icon slot="activator" small>
                    <v-icon small>$vuetify.icons.info</v-icon>
                  </v-btn>
                </v-tooltip>
                <!--<v-menu left>-->
                <!--<v-btn class="mx-0 px-0" icon slot="activator">-->
                <!--<v-icon small>$vuetify.icons.more</v-icon>-->
                <!--</v-btn>-->
                <!--<v-list dense>-->
                <!--<v-list-tile-->
                <!--&gt;-->
                <!--<v-list-tile-title class="pr-1">-->
                <!--<v-icon class="pr-3" small>$vuetify.icons.details</v-icon>-->
                <!--查看规则-->
                <!--</v-list-tile-title>-->
                <!--</v-list-tile>-->
                <!--<v-list-tile>-->
                <!--<v-list-tile-title class="pr-1">-->
                <!--<v-icon class="pr-3" small>$vuetify.icons.add</v-icon>-->
                <!--添加细分规则-->
                <!--</v-list-tile-title>-->
                <!--</v-list-tile>-->
                <!--<v-list-tile>-->
                <!--<v-list-tile-title class="pr-1">-->
                <!--<v-icon class="pr-3" small>$vuetify.icons.delete</v-icon>-->
                <!--删除规则-->
                <!--</v-list-tile-title>-->
                <!--</v-list-tile>-->
                <!--</v-list>-->
                <!--</v-menu>-->
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <!--<span>双击跳转</span>-->
      <!--</v-tooltip>-->
    </v-card>
  </l-layout>
</template>

<script>
import {time} from '../../../ladmin/utils/time'

export default {
  name: 'ViolationRuleManagement',
  data: () => ({
    bcItems: [],
    selected: -1,
    errorData: {
      error: false,
      message: '',
      code: 1
    },
    loading: false,
    items: [],
    headers: [
      {text: '规则名称', value: 'name', align: 'left', placeholder: 'N/A', sortable: false},
      {text: '上次编辑', value: 'lastEditor', align: 'right', placeholder: 'N/A', sortable: false},
      {text: '创建时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v), sortable: false},
      {text: '', value: '', align: 'right', width: '160px', sortable: false}
    ]
  }),
  computed: {
    rules: {
      get () {
        return this.$store.state.violation.ruleList
      }
    },
    currentParent () {
      if (this.isRoot) {
        return null
      }
      else {
        return this.bcItems[this.bcItems.length - 1]
      }
    },
    isRoot () {
      return !this.bcItems.length
    },
    hasChildren () {
      return (item) => {
        return item.children && item.children.length !== 0
      }
    },
    tdItemValue () {
      return (val, header) => {
        if (header instanceof Object && typeof header.f === 'function') {
          return header.f(val)
        }
        else {
          return val
        }
      }
    }
  },
  methods: {
    async deleteRule (item) {
      if (this.hasChildren(item)) {
        this.$L.alert('error', '禁止删除含有细分规则的规则')
        return
      }
      let {res, close} = await this.$L.confirm({
        title: '确认删除',
        text: '确认删除此规则？'
      })
      if (res) {
        try {
          await this.$store.dispatch('violation/deleteRules', [item])
          this.$L.alert('success', '删除成功')
          this.refresh()
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    pop (item) {
      let bcs = this.bcItems
      while (this.bcItems.length > 0) {
        let bc = bcs[bcs.length - 1]
        if (item.id === bc.id) {
          this.items = bc.children
          break
        }
        else {
          bcs.pop()
        }
      }
      if (bcs.length === 0) {
        this.items = this.rules
      }
    },
    go (item) {
      // console.log('go', item)
      // if (this.hasChildren(item)) {
      this.push(item)
      // }
      // else {
      // this.goDetails(item)
      // }
    },
    goNew () {
      if (this.$L.tab.find(tab => tab.name === 'NewViolationRule')) {
        this.$L.confirm({
          title: '提示',
          icon: '$vuetify.icons.alert',
          iconColor: 'warning',
          text: '请您编辑完成当前规则后再创建新规则',
          disableCancel: true
        }).then(({close}) => close())
      }
      else {
        this.$router.push(
          {
            name: 'NewViolationRule',
            query: {parent: this.currentParent ? this.currentParent.code : 'root'}
          }
        )
      }
    },
    push (item) {
      this.bcItems.push(item)
      this.items = item.children || []
    },
    showError (msg, code) {
      this.errorData = {
        error: true,
        message: msg,
        code: code
      }
    },
    resetError () {
      this.errorData = {
        error: false,
        code: 1,
        message: ''
      }
    },
    findDir () {
      let newItems = this.rules

      for (let bc of this.bcItems) {
        let i = newItems.findIndex(item => item.id === bc.id)
        if (i >= 0) {
          newItems = newItems[i].children
        }
        else {
          break
        }
      }
      this.items = newItems
    },
    async refresh () {
      this.loading = true
      this.resetError()
      await this.getRules()
      this.loading = false
    },
    async getRules () {
      try {
        await this.$store.dispatch('violation/getRules', {})
        this.findDir()
      }
      catch (e) {
        this.showError(e.message, e.code)
      }
    },
    goDetails (item) {
      this.$router.push({
        name: 'ViolationRuleDetails',
        params: {name: item.name},
        query: {id: item.id, parent: this.currentParent ? this.currentParent.code : 'root'}
      })
    }
  },
  activated () {
    if (this.$route.params.refresh) {
      this.refresh()
    }
  },
  created () {
    this.refresh()
  }
}
</script>

<style scoped>

</style>
